module.exports = __webpack_public_path__ + "img/fig12.4c36ac79.jpg";